// client/src/App.js

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../../App.css";
import CommonContext from '../../commonContext';
import { customColors } from '../../utils/customColors';
import Utilities from '../../utils/utils.js';

import {
  Center,
  Spinner,
  Card,
  CardBody,
  Button,
  Flex,
  Stack,
  useToast,
  Box,
  Text,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import { IoChevronBack } from "react-icons/io5";
import { postCall } from '../../utils/requests';
import Utils from '../../utils/utils';
import { AiFillSave } from "react-icons/ai";
import { IoChevronForwardOutline } from 'react-icons/io5';


import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';

import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { SortableItemVideo } from '../../components/SortableItemVideo';



function SortVideos() {

  /* TODO const navigate = useNavigate(); */
  const commonContext = React.useContext(CommonContext);

  const logout = () => {
    localStorage.removeItem("accessToken");
    /* TODO navigate('/'); */
  }

  /* utils */
  const toast = useToast();
  const ref = React.useRef(null);


  /* delete form */
  const navigate = useNavigate();
  const [allData, setAllData] = React.useState([])
  const [originalData, setOriginalData] = React.useState([])
  const [selectedCategory, setSelectedCategory] = React.useState("0")
  const [selectedName, setSelectedName] = React.useState("")
  const [isOpenAlertConfirm, setIsOpenAlertConfirm] = React.useState(false)
  const [videos, setVideos] = React.useState([])
  const [originalVideos, setOriginalVideos] = React.useState([])
  const [prevCategory, setPrevCategory] = React.useState("")
  const [currentCategory, setCurrentCategory] = React.useState("")
  const [currentCategoryId, setCurrentCategoryId] = React.useState("-1")
  const [loading, setLoading] = React.useState(false)
  const cancelRef = React.useRef()

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );



  const handleGoBack = () => {

    if (videos.length > 0) {
      console.log("there are videos")
      if (JSON.stringify(originalVideos) !== JSON.stringify(videos)) {
        openAlertConfirm()
        return
      } else {
        setVideos([])
        return
      }
    }

    if (selectedCategory !== "0") {
      setCurrentCategory(prevCategory)
      setPrevCategory("")
      setSelectedCategory("0")
      setSelectedName("")
      return
    } else {
      navigate(-1)
    }
  };

  const openAlertConfirm = () => setIsOpenAlertConfirm(true)

  const onCloseAlertConfirm = (e) => {
    setIsOpenAlertConfirm(false)
    if (e.target.innerHTML === "Si") {
      setVideos([])
    }
  }

  const fetchCategories = async () => {


    postCall("/fetchCat", {}).then((data) => {


      setAllData(Array.from(data.data.map((item) => {


        return {
          id: item.id_category,
          name: item.name,
          advices: item.advices,
          trainWithMe: item.train_with_me,
          created_at: Utils.convertDateToIta(item.creation_date, true),
          in_home: item.in_home,
          creation_date: item.creation_date,
          has_subcat: item.has_subcat ?? "0",
          id_father: item.id_father

        }
      })));

      setOriginalData(Array.from(data.data.map((item) => {
        return {
          id: item.id_category,
          name: item.name,
          advices: item.advices,
          trainWithMe: item.train_with_me,
          created_at: Utils.convertDateToIta(item.creation_date, true),
          in_home: item.in_home,
          creation_date: item.creation_date,
          has_subcat: item.has_subcat ?? "0",
          id_father: item.id_father

        }
      })));
    });
  }


  const fetchVideos = async (id_category, name) => {

    setLoading(true)
    await Utilities.sleep(200)

    try {
      setPrevCategory(currentCategory)
      setCurrentCategory(name)
      setCurrentCategoryId(id_category)

      postCall("/fetchVideosForCat", {
        id_category: id_category
      }).then((data) => {
        setLoading(false)


        if (data.data.length < 1) {
          toast({
            title: "Attenzione",
            description: "Non ci sono video per questa categoria",
            status: "warning",
            duration: 2000,
            isClosable: true,
            position: "top"
          })
        } else {
          setVideos(Array.from(data.data.map((item) => {


            return {
              id: item.id_video,
              title: item.title,
              created_at: Utils.convertDateToIta(item.created_on, true),
              created_on: item.created_on,
              id_category: item.id_category

            }
          })));

          setOriginalVideos(Array.from(data.data.map((item) => {
            return {
              id: item.id_video,
              title: item.title,
              created_at: Utils.convertDateToIta(item.created_on, true),
              created_on: item.created_on,
              id_category: item.id_category

            }
          })));
        }

      });

    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCategories()
    commonContext.setCurrentPath("Video")
    commonContext.setCurrentPage("videolist")

  }, []);

  const handleSubmit = async () => {

    postCall("/sortVideos", {
      videos: JSON.stringify(videos)
    }).then((data) => {
      if (data.status === "success") {
        toast({
          title: "Perfetto",
          description: "Ordinamento salvato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })

        fetchVideos(currentCategoryId, selectedName)
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }
    });
  }

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active.id !== over.id) {
      setVideos((items) => {
        const oldIndex = items.indexOf(items.filter(obj => obj.id === active.id)[0]);
        const newIndex = items.indexOf(items.filter(obj => obj.id === over.id)[0]);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  }

  const updateCurrentCat = (id, name) => {
    setPrevCategory(currentCategory)
    setCurrentCategory(name)
    setSelectedCategory(id)
    setSelectedName(name)

  }


  return (
    <div style={{ "width": "100%", textAlign: "center", height: "100%", overflowY: "scroll" }}>

      {/* BEGIN - ALERT ask confirmation */}
      <AlertDialog
        isOpen={isOpenAlertConfirm}
        leastDestructiveRef={cancelRef}
        onClose={onCloseAlertConfirm}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              ATTENZIONE
            </AlertDialogHeader>

            <AlertDialogBody>
              Sei sicuro di voler tornare indietro senza salvare le modifiche effettuate?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseAlertConfirm}>
                No
              </Button>
              <Button colorScheme='red' onClick={onCloseAlertConfirm} ml={3}>
                Si
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* END - ALERT ask confirmation*/}

      {/* BEGIN - TOP ROW */}
      <Stack pr="20px" mt="2%" ml="2" mb="10" direction='row' spacing={4} justifyContent="space-between">
        <Flex justifyContent="left" w="100%" >
          <Button mr="20px" leftIcon={<IoChevronBack />} colorScheme='green' variant='solid' onClick={() => { handleGoBack() }}>
            Indietro
          </Button>
          {videos.length > 0 && <Button isDisabled={JSON.stringify(originalVideos) === JSON.stringify(videos)} mr="20px" leftIcon={<AiFillSave />} colorScheme="orange" variant='solid' onClick={() => { handleSubmit() }}>
            Salva
          </Button>}

        </Flex>

      </Stack>
      <Stack direction='row' spacing={4} justifyContent="center">
        {selectedCategory !== "0" && selectedName !== "" && videos.length < 1 &&
          <Flex>
            <Text
              mb="30px"
              fontSize="2xl"
            >Sottocategorie di:</Text>
            <Text
              mb="30px"
              ml="10px"
              as="b"
              fontSize="2xl"
            >{selectedName}</Text>
          </Flex>
        }

        {videos.length > 0 &&
          <Flex>
            <Text
              mb="30px"
              fontSize="2xl"
            >Video di:</Text>
            <Text
              mb="30px"
              ml="10px"
              as="b"
              fontSize="2xl"
            >{currentCategory}</Text>
          </Flex>
        }
      </Stack>
      <Stack direction='row' spacing={4} justifyContent="center">


        {videos.length > 0 && <Text
          mb="30px"
          ml="10px"
          as="b"
          color="red"
          fontSize="lg"
        >Trascina i video per ordinarli e premi il tasto Salva per applicare le modifiche</Text>}

        {videos.length < 1 && <Text
          mb="30px"
          ml="10px"
          as="b"
          color="red"
          fontSize="lg"
        >Seleziona una categoria</Text>}

      </Stack>
      {/* END - TOP ROW */}
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        justifyContent="center"
        textAlign="center"
        align="center"
      >

        <Box
          w="100%"
          align="center"
          justifyContent="center"
          pb="180px"
        >

          {videos.length > 0 && <SortableContext
            items={videos}
            strategy={verticalListSortingStrategy}
            align="center"
            justifyContent="center"
          >
            {videos.map(video => (
              <Box display="flex" alignItems="center">
                <SortableItemVideo
                  key={video.id}
                  id={video.id}
                  title={video.title}
                  myfunc={updateCurrentCat}
                />


              </Box>
            ))}
          </SortableContext>}




          {videos.length < 1 && <Box>{allData.map(category => ((selectedCategory === category.id_father || (selectedCategory === "0" && category.id_father === 0)) &&
            <Box display="flex" alignItems="center">
              <Flex
                style={{
                  width: "70%",
                  align: "center",
                  justifyContent: "left",
                  display: "flex",
                  alignItems: "bottom",
                  marginLeft: "29%",
                }}
              /*  display="flex" */

              >

                <Card
                  borderBottomRightRadius={category.has_subcat === "1" ? "0px" : "5px"}
                  borderTopRightRadius={category.has_subcat === "1" ? "0px" : "5px"}
                  cursor="pointer"
                  mr="0px"
                  mt="10px"
                  w="60%"
                  color={customColors.textPalette1}
                  bg={customColors.appColor4}

                >
                  <CardBody
                    ref={ref}
                    onClick={() => {
                      if (category.has_subcat === "0") {
                        fetchVideos(category.id, category.name)
                      }
                    }}
                  >
                    <Box /* display="flex" */
                      alignItems="center"
                      justifyContent="center">
                      <Text align="center" as="b">{category.name}</Text>
                    </Box>
                  </CardBody>
                </Card>
                {category.has_subcat === "1" && <Button
                  /* display="flex" */
                  borderTopLeftRadius="0px"
                  borderBottomLeftRadius="0px"
                  mt="10px"
                  w="20%"
                  h={ref.current ? ref.current.clientHeight + "px" : "64px"}
                  onClick={() => {
                    updateCurrentCat(category.id, category.name)
                  }}
                  colorScheme="teal"
                  variant="solid"
                >Sottocategorie <IoChevronForwardOutline style={{ marginLeft: "20px" }} />
                </Button>}

              </Flex >


            </Box>
          ))}</Box>}
        </Box>

      </DndContext>
      {/* BEGIN - LOADING */}
      {loading &&

        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          backgroundColor="rgba(0, 0, 0, 0.5)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={9999}
          pointerEvents="none">
          <Box
            h="300"
            w="300"
            borderRadius="md"
            backgroundColor="white"
            zIndex={9999}
            display="flex"


          >
            <Flex h="300px" alignItems="center" justifyContent="center">
              <Stack spacing={5} w="300px">
                <Center>
                  <Text fontSize="xl" as="b" color="teal">Caricamento</Text>
                </Center>
                <Center >
                  <Spinner
                    thickness='4px'
                    speed='0.65s'
                    emptyColor='gray.200'
                    color='blue.500'
                    size='xl'
                  />
                </Center>

              </Stack>
            </Flex>
          </Box>
        </Box>
      }

      {/* END - LOADING */}
    </div>
  );

}

export default SortVideos;